/**
 * Canvas compliance checklist shown while passport generate is running.
 * Values are filled from the selected preset / spec at runtime.
 */

export const COMPLIANCE_STATUS = {
  PENDING: "pending",
  CHECKING: "checking",
  PASS: "pass",
  NEUTRAL: "neutral",
};

/** Pause after a row finishes before the next one starts. */
export const COMPLIANCE_ROW_PAUSE_MS = 412;

/** Typewriter speed (ms per character). */
export const COMPLIANCE_TYPE_MS = 53;

/**
 * @param {{
 *   documentName?: string,
 *   country?: string,
 *   documentType?: string,
 *   qualityLabel?: string,
 *   backgroundHex?: string,
 *   widthMm?: number,
 *   heightMm?: number,
 * }} ctx
 */
export function buildPassportComplianceChecks(ctx = {}) {
  const documentName = ctx.documentName || "Passport photo";
  const country = ctx.country || "—";
  const documentType = ctx.documentType || "Passport";
  const qualityLabel = ctx.qualityLabel || "300 DPI";
  const backgroundHex = ctx.backgroundHex || "#FFFFFF";
  const widthMm = ctx.widthMm ?? 35;
  const heightMm = ctx.heightMm ?? 45;

  return [
    {
      id: "document_name",
      label: "Name of document:",
      valueType: "text",
      value: documentName,
    },
    {
      id: "country",
      label: "Country:",
      valueType: "text",
      value: country,
    },
    {
      id: "document_type",
      label: "Type of document:",
      valueType: "text",
      value: documentType,
    },
    {
      id: "quality",
      label: "Quality:",
      valueType: "text",
      value: qualityLabel,
    },
    {
      id: "background",
      label: "Background color:",
      valueType: "swatch",
      value: backgroundHex,
    },
    {
      id: "photo_size",
      label: "Photo size:",
      valueType: "text",
      value: `Width: ${widthMm}mm, Height ${heightMm}mm`,
    },
    {
      id: "meets_requirements",
      label: "Meets requirements:",
      valueType: "text",
      value: "Yes",
    },
    {
      id: "definition",
      label: "Image definition parameters:",
      valueType: "text",
      value: "Correct",
    },
    {
      id: "printable",
      label: "Printable:",
      valueType: "text",
      value: "Yes",
      statusOnDone: COMPLIANCE_STATUS.NEUTRAL,
    },
    {
      id: "online",
      label: "Suitable for online submission:",
      valueType: "text",
      value: "Yes",
    },
  ];
}
